import { useEffect } from 'react';

import { SITE } from '@config/site';

/**
 * Sets the document title and meta description for the current page.
 *
 * Written imperatively rather than by rendering <title> and relying on
 * React 19 hoisting: index.html already carries a static title and
 * description for crawlers and no-JS visitors, and a hoisted second <title>
 * would lose to the first one in the document.
 */
export const useDocumentMeta = (
  title: string | undefined,
  description: string | undefined,
): void => {
  useEffect(() => {
    document.title = title ? `${title} — ${SITE.name}` : `${SITE.name} — ${SITE.tagline}`;

    const meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (meta) meta.content = description ?? SITE.description;
  }, [title, description]);
};
